import { jsx as ___EmotionJSX } from "@emotion/core";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import React from 'react';
import { css } from '@emotion/core';

var _ref = process.env.NODE_ENV === "production" ? {
  name: "70qvj9",
  styles: "display:flex;align-items:center;"
} : {
  name: "70qvj9",
  styles: "display:flex;align-items:center;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9tb2R1bGVzL2F1dGhlbnRpY2F0aW9uL2NvbXBvbmVudHMvbG9naW4vU3RlcE5hdmlnYXRpb24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVVrQiIsImZpbGUiOiIuLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9hdXRoZW50aWNhdGlvbi9jb21wb25lbnRzL2xvZ2luL1N0ZXBOYXZpZ2F0aW9uLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5cbnR5cGUgU3RlcE5hdmlnYXRpb25Qcm9wcyA9IHt9XG5cbmNvbnN0IFN0ZXBOYXZpZ2F0aW9uOiBSZWFjdC5GdW5jdGlvbkNvbXBvbmVudDxTdGVwTmF2aWdhdGlvblByb3BzPiA9ICh7IGNoaWxkcmVuIH0pID0+IHtcbiAgY29uc3QgcmVzdWx0ID0gKFxuICAgIDw+XG4gICAgICB7Y2hpbGRyZW4gJiYgKFxuICAgICAgICA8ZGl2XG4gICAgICAgICAgY3NzPXtjc3NgXG4gICAgICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAgICBgfVxuICAgICAgICA+XG4gICAgICAgICAge2NoaWxkcmVufVxuICAgICAgICA8L2Rpdj5cbiAgICAgICl9XG4gICAgPC8+XG4gIClcbiAgcmV0dXJuIHJlc3VsdFxufVxuXG5leHBvcnQgZGVmYXVsdCBTdGVwTmF2aWdhdGlvblxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var StepNavigation = function StepNavigation(_ref2) {
  var children = _ref2.children;

  var result = ___EmotionJSX(React.Fragment, null, children && ___EmotionJSX("div", {
    css: _ref
  }, children));

  return result;
};

export default StepNavigation;